import React from "react";
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"

const MoreFeaturesSection = () => {
  return (
    <div className="w-full flex items-center justify-center px-[16px] md:px-px1_l xl:px-px1_xl my-[60px] md:my-[80px]">
      <CMSRender
        contentType="MoreFeaturesSection"
        renderItem={(data, id) => {
          return (
            /*Colored Container*/
            <div className="w-full max-w-w1_xl flex flex-col items-center justify-center bg-gradient_more_features rounded-[50px] md:rounded-[70px] px-6 xl:px-px1_xl pt-[70px] pb-[64px]"> 
              {/* Heading */}
              <Typography 
                component="h2"
                variant="h1"
                className="text-text text-center px-1 md:px-0 mb-8 md:mb-[64px] lg:mb-[124px]"
              >
                {data.title}
              </Typography>

              {/* Cards */}
              <div className="flex flex-col md:flex-row flex-wrap xl:flex-nowrap justify-center md:gap-[30px] lg:gap-[30px] xl:gap-[60px]">
                {data.cards.map((card, index) => (
                  <div key={index} className="flex flex-col items-center text-center p-4 w-full max-w-[362px]">
                    {/* Card Icon */}
                    <div className="w-[70px] h-[70px] text-primary mb-[30px]">
                      <img 
                        src={card.icon} 
                        alt="icon" 
                        className="w-[70px] h-[70px]" 
                      />
                    </div>
                    
                    {/* Card Title */}
                    <Typography 
                    variant="h3"
                      className="xl:h-20 text-text mb-2 xl:mb-0"
                    >
                      {card.title}
                    </Typography>
                      
                      {/* Card Info */}
                    <Typography 
                      variant="body1"
                    >
                      {card.info}
                    </Typography>
                  </div>
                ))}
              </div>
            </div>
          )
        }}
      />
    </div>
  );
};

export default MoreFeaturesSection;

